









import { Component, Vue } from 'vue-property-decorator';
import { Getter, Mutation, Action } from 'vuex-class';
import { IFilter } from '@/store/types/IRootState';
import { formatString } from '@/services/StringFormatter';

@Component({
  methods: {
    formatString,
  },
})
export default class CheckedFiltersComponent extends Vue {
  @Getter public getCheckedFilters!: IFilter[];
  @Mutation private checkFilter: any;
  @Action private fetchItems: any;

  public toggleFilter(filter: IFilter): void {
    this.checkFilter({name: filter.name, filterValue: filter.value });
    this.fetchItems({ generateFilters: false });
  }
}
